// removed by extract-text-webpack-plugin
module.exports = {"avatar-container":"avatar-container__WKfSE","shadow":"shadow__1KHgj","year-container":"year-container__1glFv","row-1":"row-1__3OYro","row-2":"row-2__2VHDi","text-green":"text-green__F5tTF","ts":"ts__2xLyg","w-100":"w-100__36Hme","gw":"gw__1_UPg"};


//////////////////
// WEBPACK FOOTER
// ./styles/f2s/investmentDetailsCard.scss
// module id = 595
// module chunks = 68